import axios from 'axios'

// Get all shows from business
const getAll = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/evento`)
  return data
}

const getCurrentShows = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/evento/current`)
  return data
}
// Get show from id
const get = async (id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/evento/${id}/business`)
  return data
}

// Create show
const create = async (
  name,
  type,
  producer,
  duration,
  censor,
  description,
  image,
  censorFollowed,
  online = false,
  live = false,
  liveUrl = null,
  showcaseBusiness,
  privateShow = false
) => {
  const formData = new FormData()
  if (name) formData.append('name', name)
  if (type) formData.append('type', type)
  if (producer) formData.append('producer', producer)
  if (duration) formData.append('duration', duration)
  formData.append('censor', censor)
  if (description) formData.append('description', description)
  if (image) formData.append('image1', image)
  if (censorFollowed) formData.append('censorFollowed', censorFollowed)
  formData.append('online', online)
  formData.append('live', live)
  formData.append('showcaseBusiness', showcaseBusiness)
  formData.append('privateShow', privateShow)
  if (liveUrl) formData.append('liveUrl', liveUrl)
  const { data } = await axios.post(`${process.env.VUE_APP_API}/evento`, formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  )
  return data
}

// Update show
const update = async (
  id,
  name,
  type,
  producer,
  duration,
  censor,
  description,
  image,
  censorFollowed,
  online = false,
  live = false,
  liveUrl = null,
  showcaseBusiness = false,
  privateShow = false
) => {
  const formData = new FormData()
  if (name) formData.append('name', name)
  if (type) formData.append('type', type)
  if (producer) formData.append('producer', producer)
  if (duration) formData.append('duration', duration)
  formData.append('censor', censor)
  if (description) formData.append('description', description)
  if (image) formData.append('image1', image)
  if (censorFollowed) formData.append('censorFollowed', censorFollowed)
  formData.append('online', online)
  formData.append('live', live)
  formData.append('showcaseBusiness', showcaseBusiness)
  formData.append('privateShow', privateShow)
  if (liveUrl) formData.append('liveUrl', liveUrl)
  const { data } = await axios.put(`${process.env.VUE_APP_API}/evento/${id}`, formData,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  )
  return data
}

// Get previous show prices
const getPreviousPrice = async (id) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/evento/${id}/previous-price`)
  return data
}

export {
  getAll,
  getCurrentShows,
  get,
  create,
  update,
  getPreviousPrice
}
